import {decorateDateString} from "./decorateDateString";

export function populateGeneralData(element,data) {
    const {sum_comments,sum_prosts,post_date}=data;
    element.find(".js-comment-count").text(sum_comments);
    element.find(".js-prost-count").text(sum_prosts);
}